<template>
    <el-dialog
            :title="'添加管理员'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm"  ref="dataForm" :rules="rules" @keyup.enter.native="dataFormSubmit()"
                 label-width="120px">
            <!-- 禁止浏览器自动填充账户名密码 -->
            <input style="display: none" type="text" name="fakeusernameremembered" />
            <input style="display: none" type="password" name="fakepasswordremembered" />
            <!-- /禁止浏览器自动填充账户名密码 -->
            <el-form-item label="用户名:" prop="userName">
                <el-input v-model="dataForm.userName" placeholder="用户名" autocomplete="new-password"></el-input>
            </el-form-item>
            <el-form-item label="姓名:" prop="realName">
                <el-input v-model="dataForm.realName" placeholder="姓名" autocomplete="new-password"></el-input>
            </el-form-item>
            <el-form-item label="密码:" prop="password">
                <el-input v-model="dataForm.password" type="password" placeholder="密码"
                          autocomplete="new-password"></el-input>
            </el-form-item>
            <el-form-item label="手机号码:" prop="mobile" class="input-media">
                <el-input v-model="dataForm.mobile" placeholder="手机号码"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱:" prop="email" class="input-media">
                <el-input v-model="dataForm.email" placeholder="电子邮箱"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
import Crypto from '@/utils/crypto';
    export default {
        data() {
            return {
                visible: false,
                dataForm:{
                    realName:'',
                    userName:'',
                    password:'',
                    mobile:'',
                    email:'',
                    internalRoleId:'',
                    orgId:''
                },
                rules: {
                    userName: [
                        {required: true, message: '输入用户名', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '密码不能为空', trigger: 'blur'},
                    ],
                    realName: [
                        {required: true, message: '输入用户名', trigger: 'blur'},
                    ],
                    mobile: [
                        {required: true, message: '输入手机号码', trigger: 'blur'},
                    ],
                    email: [
                        {required: true, message: '输入邮箱号码', trigger: 'blur'},
                    ],
                }
            }
        },
        methods: {
            resetForm() {
                this.$refs['dataForm'].resetFields();
            },
            init(internalRole,orgId) {
                this.visible = true
                this.dataForm.orgId=orgId
                this.dataForm.internalRoleId=internalRole
                this.$nextTick(() => {
                    this.resetForm()
                })
            },
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return
                    }
                    this.dataSubmit()
                })
            },
            // 表单提交
            dataSubmit() {
                if(this.dataForm.internalRoleId==='' || this.dataForm.internalRoleId===undefined){
                    this.$message.error('请选择角色')
                    return
                }
                this.dataForm.password = Crypto.encrypt(this.dataForm.password)
                this.$http({
                    url: '/auth/employee/saveorupdate',
                    method: 'post',
                    data: this.dataForm
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '添加成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-select{
        width: 100%;
    }
</style>
